// extracted by mini-css-extract-plugin
export var aircallIframe = "_kf-3";
export var fabContainer = "_kf-5";
export var fabRinging = "_kf-6";
export var loadingOverlay = "_kf-4";
export var pulse = "_kf-7";
export var widgetContent = "_kf-2";
export var widgetPanel = "_kf-0";
export var widgetPanelExpanded = "_kf-1";